
export const PUBLIC_INSURANCE_KEYS = [
  'PUB_OTHER',
  'PUB_AOK',
  'PUB_TK',
  'PUB_BARMER_GEK',
  'PUB_DAK',
] as const;
export const PRIVATE_INSURANCE_KEYS = [
  'PRIV_OTHER',
  'PRIV_DEBEKA',
  'PRIV_DKV',
  'PRIV_ALLIANZ',
  'PRIV_AXA',
] as const;
export const INSURANCE_KEYS = [
    ...PUBLIC_INSURANCE_KEYS,
    ...PRIVATE_INSURANCE_KEYS
] as const;

export type InsuranceKey = (typeof INSURANCE_KEYS)[number];
export type PublicInsuranceKey = (typeof PUBLIC_INSURANCE_KEYS)[number];
export type PrivatInsuranceKey = (typeof PRIVATE_INSURANCE_KEYS)[number];

export const isInsuranceKey = (value: unknown): value is InsuranceKey =>
  INSURANCE_KEYS.includes(value as InsuranceKey);

export const isPublicInsuranceKey = (value: unknown): value is PublicInsuranceKey =>
  PUBLIC_INSURANCE_KEYS.includes(value as PublicInsuranceKey);

export const isPrivateInsuranceKey = (value: unknown): value is PrivatInsuranceKey =>
  PRIVATE_INSURANCE_KEYS.includes(value as PrivatInsuranceKey);